import { render, staticRenderFns } from "./QuoteMargin.vue?vue&type=template&id=0d442f90&scoped=true"
import script from "./QuoteMargin.vue?vue&type=script&lang=js"
export * from "./QuoteMargin.vue?vue&type=script&lang=js"
import style0 from "./QuoteMargin.vue?vue&type=style&index=0&id=0d442f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d442f90",
  null
  
)

export default component.exports